<div nxLayout="grid maxwidth" class="profile-edit">
    <div nxRow>
        <div nxCol="12">
            <nx-link>
                <a routerLink="/moj-profil">
                    <nx-icon name="chevron-left" nxIconPositionStart aria-hidden="true"></nx-icon>
                    <span translate>profile.edit.texts.back</span>&nbsp;
                </a>
            </nx-link>
            <h3 nxHeadline="subsection" class="nx-margin-bottom-m" translate>
                profile.edit.texts.headline
            </h3>
            <cpc-panel-group *ngIf="form">
                <cpc-panel>
                    <div nxRow>
                        <div nxCol="12" class="panel-header panel-header__margin nx-margin-bottom-m">
                            <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m nx-font-weight-semibold"
                                translate>
                                profile.edit.texts.personal-data
                            </h3>
                        </div>
                    </div>
                    <form [formGroup]="form" (submit)="updateProfile($event)">
                        <div nxRow>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'profile.texts.first-name' | translate }}">
                                    <input nxInput formControlName="firstName" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.last-name' | translate }}">
                                    <input nxInput formControlName="lastName" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.title' | translate }}">
                                    <input nxInput formControlName="title" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.date-of-birth' | translate }}">
                                    <input nxInput formControlName="dateOfBirth" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.maiden-name' | translate }}">
                                    <input nxInput formControlName="maidenName" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.id-number' | translate }}">
                                    <input nxInput formControlName="idNumber" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'profile.texts.email-address' | translate }}">
                                    <input nxInput formControlName="email" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.mobile' | translate }}">
                                    <input nxInput formControlName="mobile" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.edit.texts.id-card-type-label' | translate }}">
                                    <nx-dropdown formControlName="idCardType">
                                        <ng-template ngFor let-type="$implicit" [ngForOf]="identityCardTypes">
                                            <nx-dropdown-item [value]="type">
                                                {{ 'profile.edit.texts.id-card-type.' + type | translate }}
                                            </nx-dropdown-item>
                                        </ng-template>
                                    </nx-dropdown>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.id-card' | translate }}">
                                    <input nxInput formControlName="idCard" />
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.valid-to' | translate }}">
                                    <input nxDatefield nxInput [datepicker]="datePicker" formControlName="validTo"
                                        [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
                                    <nx-datepicker-toggle [for]="datePicker" nxFormfieldSuffix></nx-datepicker-toggle>
                                    <nx-datepicker #datePicker></nx-datepicker>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.issued-by' | translate }}">
                                    <input nxInput formControlName="issuedBy" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12,12,12,4">
                                <nx-formfield label="{{ 'profile.texts.country' | translate }}">
                                    <nx-dropdown formControlName="country" [showFilter]="true">
                                        <ng-template ngFor let-country="$implicit" [ngForOf]="countries">
                                            <nx-dropdown-item [value]="country.twoLetterCountryCode">
                                                {{ currentLang == 'SK' ? country.skCountryName : country.enCountryName }}
                                            </nx-dropdown-item>
                                        </ng-template>
                                    </nx-dropdown>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.zip' | translate }}">
                                    <input nxInput formControlName="zip" *ngIf="this.form.value.country !== 'SK'" />
                                    <nx-dropdown formControlName="zip" [showFilter]="true"
                                        *ngIf="this.form.value.country == 'SK'" [options]="zips">
                                    </nx-dropdown>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.city' | translate }}">
                                    <input nxInput formControlName="city" *ngIf="this.form.value.country !== 'SK'" />
                                    <nx-dropdown formControlName="city" [showFilter]="true"
                                        *ngIf="this.form.value.country == 'SK'" [options]="cities">
                                    </nx-dropdown>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.street' | translate }}">
                                    <input nxInput formControlName="street" [nxAutocomplete]="streetsAuto"/>
                                    <!--<nx-dropdown formControlName="street" [showFilter]="true"
                                        *ngIf="this.form.value.country == 'SK'" [options]="streets">
                                    </nx-dropdown>-->
                                    <nx-autocomplete #streetsAuto="nxAutocomplete">
                                        <nx-autocomplete-option [value]="street" *ngFor="let street of streets">
                                            {{ street }}
                                        </nx-autocomplete-option>
                                    </nx-autocomplete>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.house-number' | translate }}">
                                    <input nxInput formControlName="houseNumber" />
                                </nx-formfield>
                            </div>
                        </div>
                        <div nxRow rowJustify="end">
                            <a nxButton="secondary normal" class="nx-margin-right-m" routerLink="/moj-profil">
                                <span translate>profile.edit.texts.cancel</span>
                            </a>
                            <button nxButton="primary normal" type="submit">
                                <span translate>profile.edit.texts.save</span>
                            </button>
                        </div>
                    </form>
                </cpc-panel>
            </cpc-panel-group>
        </div>
    </div>
</div>